export default __webpack_public_path__ + "static/media/info-04.b4154512.png";